import { createSlice } from '@reduxjs/toolkit';
import { AdminPaydOrdersState } from '../../components/interfaces';
import { fetchAdminPaydOrders } from '../../services';

const initialState: AdminPaydOrdersState = {
  orders: [],
  status: 'idle',
  error: null,
  total: 0,
};

const adminPaydOrdersSlice = createSlice({
  name: 'adminPaydOrders',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAdminPaydOrders.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchAdminPaydOrders.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.orders = action.payload.orders;
        state.total = action.payload.total;
      })
      .addCase(fetchAdminPaydOrders.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload as string;
      });
  },
});

export default adminPaydOrdersSlice.reducer;
